import createStore from "astrid-helpers/src/createStore";
import { getOffset, setOffset } from "./offset";
import { getPosition } from "./position";
export const initSize = 1000 * 30;
export const [getSize, setSize, useSize] = createStore(initSize);
export function resetSize() {
  const size = getSize();
  const offset = getOffset();
  const shift = (getPosition() - offset) / size;
  setSize(initSize);
  setOffset(Math.max(0, offset + (size - initSize) * shift));
}
//# sourceMappingURL=size.js.map